import React from 'react';

interface BillingProps {
    readonly color?: string;
    readonly size?: string;
}

export default function BackIcon({ color = "#79808A", size = "20" }: BillingProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.9974 18.3307C14.5998 18.3307 18.3307 14.5998 18.3307 9.9974C18.3307 5.39502 14.5998 1.66406 9.9974 1.66406C5.39502 1.66406 1.66406 5.39502 1.66406 9.9974C1.66406 14.5998 5.39502 18.3307 9.9974 18.3307Z" stroke={color} stroke-width="1.2" />
            <path d="M10 5V15M12.5 7.91667C12.5 6.76667 11.3808 5.83333 10 5.83333C8.61917 5.83333 7.5 6.76667 7.5 7.91667C7.5 9.06667 8.61917 10 10 10C11.3808 10 12.5 10.9333 12.5 12.0833C12.5 13.2333 11.3808 14.1667 10 14.1667C8.61917 14.1667 7.5 13.2333 7.5 12.0833" stroke={color} stroke-width="1.2" stroke-linecap="round" />
        </svg>
    )
}